<template>
  <TFormField :has-error="!!error">
    <slot />
    <template #label>
      <slot name="label" />
    </template>
    <template v-if="!!error" #error>
      {{ error }}
    </template>
  </TFormField>
</template>
<script setup lang="ts" generic="T extends GenericObject">
import { type FormContext, type GenericObject, type Path } from 'vee-validate';
import { computed } from 'vue';
import TFormField from './TFormField.vue';
const props = defineProps<{ form: FormContext; name: Path<T> }>();
const error = computed(() => props.form.errors.value[props.name]);
</script>
